// Presenter Archetype — plain-text ".txt" action-plan export (brief: "text
// download" alongside the direct PDF download and the print fallback).
// Mirrors the generated PDF's content structure section-for-section so all
// three outputs (screen / PDF / text) carry the exact same locked copy.

const line = (s = "") => `${s}\n`;

export const buildActionPlanText = (model) => {
  const { ui } = model;
  let out = "";

  out += line(ui.actionPlan);
  out += line(model.isBlend ? model.leaderProfiles.map((p) => p.name).join(" + ") : model.leaderProfiles[0].name);
  out += line("InterAct Globally");
  out += line();

  if (model.isBlend) {
    out += line(ui.blendTitle);
    out += line(model.blendText);
    out += line(ui.blendBody);
    if (model.leaders.length === 3) out += line(ui.broadBlend);
    out += line();
  } else {
    out += line(`${ui.resultEyebrow} \u2014 ${ui.your}`);
    out += line(model.leaderProfiles[0].essence);
    out += line();
  }

  model.leaderProfiles.forEach((p) => {
    out += line(`${ui.profile}: ${p.name} \u2014 ${p.label}`);
    out += line(`${ui.strength}: ${p.strength}`);
    out += line(`${ui.blind}: ${p.blind}`);
    out += line();
  });

  if (model.secondaryProfiles.length) {
    out += line(ui.secondary);
    out += line(ui.secondaryBody);
    model.secondaryProfiles.forEach((p) => {
      out += line(`- ${p.name}: ${p.essence}`);
    });
    out += line();
  }

  out += line(ui.breakdown);
  out += line(ui.scoring);
  out += line(`${ui.scoreLabel}:`);
  model.archetypeOrder.forEach((id) => {
    const count = model.scores[id];
    const name = model.allProfilesById[id].name;
    out += line(`${name} \u2014 ${count} ${count === 1 ? ui.singleAnswer : ui.answer}`);
  });
  out += line();

  out += line(ui.experiment);
  out += line(ui.exerciseIntro);
  model.leaderProfiles.forEach((p) => {
    out += line(`${p.name} \u2014 ${ui.exerciseTitle}`);
    p.steps.forEach((step, i) => {
      out += line(`${i + 1}. ${step}`);
    });
    out += line(`${ui.script}: "${p.script}"`);
    out += line(`${ui.delivery}: ${p.delivery}`);
    out += line(`${ui.qa}: ${p.qa}`);
    out += line();
  });

  if (model.stretchProfiles.length) {
    out += line(ui.stretchTitle);
    out += line(ui.stretchBody);
    model.stretchProfiles.forEach((p) => {
      out += line(`- ${p.name}: ${ui[`${p.id}Stretch`]}`);
    });
    out += line();
  }

  out += line(ui.method);
  out += line(ui.methodBody);
  out += line();
  out += line(ui.archetypeNote);
  out += line(ui.footer);
  out += line(model.version);
  return out;
};

export const downloadActionPlanText = (model) => {
  const text = buildActionPlanText(model);
  const blob = new Blob([text], { type: "text/plain;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `InterAct_Presenter_Archetype_${model.language}.txt`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
